<template>
  <button :class="btnClass" @click="onClick">
      {{ btnText }}
  </button>
</template>

<script>

export default {
  name: 'ButtonItem',
  props: {
    btnText: {
      type: String,
      default: ''
    },
    btnClass: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      clicked: false
    }
  },
  methods: {
    onClick (event) {
      if (!this.clicked) {
        this.clicked = true
        setTimeout(() => {
          this.clicked = false
        }, 500)
        if (this.disabled) {
          return
        }
        this.$emit('click', event)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
button {
    position: relative;
    width: 80px;
    padding: 0 5px 0 20px;
    height: 35px;
    box-sizing: border-box;
    display: inline-block;
    border: 1px solid #bbb;
    border-radius: 20px;
    margin: 0 2.5px;
    font-size: 13px;
    font-weight: 600;
    color: #444;
    transition: 0.3s;
    &:hover {
        background: #f7f7f7;
    }

    &.modify {
        background: url('../../assets/images/icon-card-btn-modify.svg') no-repeat left 10px center;
        &:hover {
            background: #f7f7f7 url('../../assets/images/icon-card-btn-modify.svg') no-repeat left 10px center;
        }
    }
    &.link {
        background: url('../../assets/images/icon-card-btn-link.svg') no-repeat left 10px center;
        border: 1px solid #ec0047;
        color: #ec0047;
        &:hover {
            background: #f7f7f7 url('../../assets/images/icon-card-btn-link.svg') no-repeat left 10px center;
        }
    }
    &.check {
        background: url('../../assets/images/icon-card-btn-check.svg') no-repeat left 10px center;
        &:hover {
            background: #f7f7f7 url('../../assets/images/icon-card-btn-check.svg') no-repeat left 10px center;
        }
    }
    &.layerpop-btn {
      width: 90px;
      height: 40px;
      padding: 0;
      font-size: 14px;
      transition: 0.3s;
      &:hover {
        background: #f7f7f7;
      }
      &.clear {
        border: 1px solid #ec0047;
        color: #ec0047;
        &:hover {
          background: #f7f7f7;
        }
      }
    }
    &.question-clear {
      width: 165px;
      height: 45px;
      line-height: 45px;
      border-radius: 22px;
      font-size: 16px;
      font-weight: 500;
      color: #fff;
      padding-left: 30px;
      border: none;
      background: #ccccca url('../../assets/images/icon-question-clear-btn.svg') no-repeat left 15px center;
      transition: 0.3s;

      &.on {
        background: #ec0047 url('../../assets/images/icon-question-clear-btn.svg') no-repeat left 15px center;
        &:hover {
          background: #c12a44 url('../../assets/images/icon-question-clear-btn.svg') no-repeat left 15px center;
        }
      }
    }
    &.pop-information {
      width: 154px;
      height: 40px;
      line-height: 40px;
      border-radius: 22px;
      font-size: 14px;
      font-weight: 500;
      color: #fff;
      padding-left: 30px;
      border: none;
      background: #ec0047 url('../../assets/images/icon-question-clear-btn.svg') no-repeat left 15px center;
      transition: 0.3s;
      &:hover {
        background: #c12a44 url('../../assets/images/icon-question-clear-btn.svg') no-repeat left 15px center;
      }
    }
    &.test-clear {
      width: 165px;
      height: 45px;
      line-height: 45px;
      border-radius: 22px;
      font-size: 16px;
      font-weight: 500;
      color: #fff;
      padding: 0;
      border: none;
      background: #ec0047;
      transition: 0.3s;
      &:hover {
        background: #c12a44;
      }
    }
    &.information {
      width: 182px;
      height: 35px;
      padding: 0;
      text-align: center;
      position: absolute;
      right: 0;
      bottom: 0;
      background: #fff;
      border: 1px solid #bbb;
      cursor: pointer;
    }
    &.logout {
      width: 100%;
      padding: 0;
      margin: 0;
    }
    &.login {
      width: 100%;
      height: 40px;
      line-height: 40px;
      border-radius: 20px;
      font-size: 14px;
      font-weight: 500;
      color: #fff;
      padding: 0;
      margin: 0;
      border: none;
      background: #ec0047;
      transition: 0.3s;
      &:hover {
        background: #c12a44;
      }
    }
}
@media screen and (max-width: 768px) {
    button {
        width: auto;
        min-width: 70px;
        &.test-clear {
          width: calc(100% - 40px);
          height: 45px;
        }
        &.information {
          width: auto;
          height: 35px;
          padding: 0 20px;
          text-align: center;
          position: absolute;
          right: 0;
          bottom: 0;
          background: #fff;
          border: 1px solid #bbb;
          cursor: pointer;
        }
        &.pop-information {
          width: 100%;
          height: 40px;
          line-height: 40px;
          border-radius: 22px;
          font-size: 14px;
          font-weight: 500;
          color: #fff;
          padding-left: 20px;
          border: none;
          background: #ec0047 url('../../assets/images/icon-question-clear-btn.svg') no-repeat left 15px center;
        }
    }
}
</style>
